import dynamic from 'next/dynamic';
import { memo } from 'react';
import { useSelector } from 'react-redux';
import { selectDestination } from '../selectors';

const GoogleMapHotel = dynamic(
  () => import('containers/Hotel/component/ggmap'),
  { ssr: false },
);

const DestinationMap = memo(() => {
  const destination = useSelector(selectDestination);

  if (!destination) return null;

  return (
    <div className="pb-25 max-md:pb-15">
      <div className="container-fluid">
        <GoogleMapHotel listHotel={destination} className="mt-8 h-[500px]" />
      </div>
    </div>
  );
});

export default DestinationMap;
